import { Backdrop, CircularProgress } from '@material-ui/core';
import React, { useState } from 'react';
import { UserProvider } from '../User/UserContext';
export const MicroApp = (props) => {
    const { children, authProvider, permittedRoles, requiredFeatures, requiredModules, translationMessages, getMe, getFeatures, CustomErrorPage } = props;
    const [isLoading, setIsLoading] = useState(true);
    const loadingCallback = () => {
        setIsLoading(false);
    };
    return (React.createElement(React.Fragment, null,
        isLoading ? React.createElement(Backdrop, { open: true },
            React.createElement(CircularProgress, { "data-testid": 'loading-progress', color: 'inherit' })) : '',
        React.createElement(UserProvider, { authProvider: authProvider, permittedRoles: permittedRoles, requiredFeatures: requiredFeatures, requiredModules: requiredModules, getMe: getMe, CustomErrorPage: CustomErrorPage, getFeatures: getFeatures, translationMessages: translationMessages, loadingCallback: loadingCallback }, children)));
};
//# sourceMappingURL=MicroApp.js.map